import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { Observable, Subject } from 'rxjs';
import * as Bowser from "bowser";
import { environment } from 'environments/environment';
import * as sdk from 'microsoft-cognitiveservices-speech-sdk';

declare var webkitSpeechRecognition: any;

@Injectable({
  providedIn: 'root'
})
export class VoiceRecognitionService {
  private recognizer: sdk.SpeechRecognizer | null = null;
  btnenabledisable: boolean = true;
  btnenabledisablecallcenter: boolean = true;
  Examinationdisable: boolean = true;
  Diagnosisdisable: boolean = true;
  MedicineNamedisable: boolean = true;
  Reviewdisable: boolean = true;
  Surgerydisable: boolean = true;
  Surgerytxtdisable: boolean = true;
  MedicineSearchdisable: boolean = true;
  Investigationdisable: boolean = true;
  NewSurgerydisable: boolean = true;
  recognition = Bowser.getParser(window.navigator.userAgent).getBrowser().name != 'Firefox' ? new webkitSpeechRecognition() : null;
  isStoppedSpeechRecog1 = false;
  isStoppedSpeechRecog2 = false;
  isStoppedSpeechRecog3 = false;
  isStoppedSpeechRecog4 = false;
  isStoppedSpeechRecog5 = false;
  isStoppedSpeechRecog9 = false;
  isStoppedSpeechRecog6 = false;
  isStoppedSpeechRecog7 = false;
  isStoppedSpeechRecog8 = false;
  isStoppedSpeechRecog10 = false;
  isStoppedSpeechRecog11 = false;
  isStoppedSpeechRecog12 = false;
  public text = '';
  public ECtext = '';
  public DCtext = '';
  public MAtext = '';
  public Surgerytext = '';
  public Reviewtext = '';
  public Surgerytxt = '';
  public MStext = '';
  public IStext = '';
  public Newtext = '';
  public callCentertext = '';
  public navigationVoiceText = '';
  tempWords: string = '';
  module: any;
  startTime: any;
  endtime: any;
  sendingtext: string;
  public speakinglang = 'en-IN';
  isDischargeRecognitionStopped = false;
  activeDischargeField = ''
  dischargeTextMap: { [key: string]: string } = {};

  public recognitionIsRunning: boolean = false;
  CRtext: string = '';
  CounselorRemarkdisable: boolean = true;
  isStoppedSpeechRecog13: boolean = false;
  navigationVoiceDisable: boolean = true;

  private navigationRouteMap: { [key: string]: string } = {};
  private allowedNavigationRoutes: Set<string> | null = null;
  private readonly navigationCorrectionRules: Array<[RegExp, string]> = [
    [/\bregistartion\b/g, 'registration'],
    [/\bregisteration\b/g, 'registration'],
    [/\bregister\b/g, 'registration'],
    [/\bdash board\b/g, 'dashboard'],
    [/\bbuilding\b/g, 'billing'],
    [/\bbillng\b/g, 'billing'],
    [/\bbillin\b/g, 'billing'],
    [/\bappoinment(s?)\b/g, 'appointment$1'],
    [/\breciept(s?)\b/g, 'receipt$1'],
    [/\blaboratory\b/g, 'lab'],
  ];

  private readonly navigationRouteSubject = new Subject<{ route: string | null; command: string; reason: 'matched' | 'unrecognized' | 'restricted' }>();
  public readonly navigationRoute$: Observable<{ route: string | null; command: string; reason: 'matched' | 'unrecognized' | 'restricted' }> = this.navigationRouteSubject.asObservable();

  constructor(public http: HttpClient, public datePipe: DatePipe,
    public authService: AuthService) {
    this.initializeNavigationRoutes();
  }

  private initializeNavigationRoutes(): void {
    const routeCatalog: Array<{ route: string; aliases?: string[] }> = [
      { route: '/layout/dashboard', aliases: ['dashboard', 'home'] },
      { route: '/layout/Registration', aliases: ['registration', 'registeration', 'new registration', 'register patient', 'patient registration'] },
      { route: '/layout/OpdVisit', aliases: ['opd', 'opd visit', 'visit'] },
      { route: '/layout/Receipts', aliases: ['receipts', 'advance receipts'] },
      { route: '/layout/Appointments', aliases: ['appointment', 'appointments'] },
      { route: '/layout/Billing', aliases: ['billing', 'bill', 'building'] },
      { route: '/layout/Billing/AdvanceReceipt', aliases: ['advance receipt', 'advance reports'] },
      { route: '/layout/Billing/RecoveryManager', aliases: ['recovery manager'] },
      { route: '/layout/reports', aliases: ['reports', 'report'] },
      { route: '/layout/reports/opd-reports', aliases: ['opd reports'] },
      { route: '/layout/reports/advance-register', aliases: ['advance register'] },
      { route: '/layout/reports/registration-reports', aliases: ['registration reports'] },
      { route: '/layout/reports/patient-registration-date-wise', aliases: ['patient registration date wise'] },
      { route: '/layout/reports/graphical-patient-registration', aliases: ['graphical patient registration'] },
      { route: '/layout/reports/patient-category-wise', aliases: ['patient category wise'] },
      { route: '/layout/reports/patient-zone-wise', aliases: ['patient zone wise'] },
      { route: '/layout/reports/appointment-register-doctor-wise', aliases: ['appointment register doctor wise'] },
      { route: '/layout/reports/surgery-date-wise-reports', aliases: ['surgery date wise reports'] },
      { route: '/layout/reports/operation-date-wise-reports', aliases: ['operation date wise reports'] },
      { route: '/layout/reports/surgeon-wise-summary', aliases: ['surgeon wise summary'] },
      { route: '/layout/reports/operation-type-wise-summary', aliases: ['operation type wise summary'] },
      { route: '/layout/reports/surgeon-month-wise-reports', aliases: ['surgeon month wise reports'] },
      { route: '/layout/reports/operation-month-wise-reports', aliases: ['operation month wise reports'] },
      { route: '/layout/reports/billing', aliases: ['billing reports', 'billing report'] },
      { route: '/layout/reports/appointment-summary-doctor-wise-report', aliases: ['appointment summary doctor wise report'] },
      { route: '/layout/reports/mis-report', aliases: ['mis report'] },
      { route: '/layout/masters', aliases: ['masters', 'master'] },
      { route: '/layout/masters/branchMaster', aliases: ['branch master'] },
      { route: '/layout/masters/accountHeadMaster', aliases: ['account head master'] },
      { route: '/layout/masters/accountTypeMaster', aliases: ['account type master'] },
      { route: '/layout/masters/accountMaster', aliases: ['account master'] },
      { route: '/layout/masters/companyMaster', aliases: ['company master'] },
      { route: '/layout/masters/surgeryMaster', aliases: ['surgery master'] },
      { route: '/layout/masters/rateListMaster', aliases: ['rate list master'] },
      { route: '/layout/masters/packageMaster', aliases: ['package master'] },
      { route: '/layout/masters/diagnosisMaster', aliases: ['diagnosis master'] },
      { route: '/layout/masters/opdtestMaster', aliases: ['opd test master'] },
      { route: '/layout/masters/categoryMaster', aliases: ['category master'] },
      { route: '/layout/masters/location', aliases: ['location master', 'location'] },
      { route: '/layout/masters/configuration', aliases: ['configuration'] },
      { route: '/layout/masters/usermanagement', aliases: ['user management'] },
      { route: '/layout/labentry', aliases: ['lab entry', 'lab'] },
      { route: '/layout/labentry/samplCollection', aliases: ['sample collection'] },
      { route: '/layout/labentry/sampleReceving', aliases: ['sample receiving'] },
      { route: '/layout/labentry/testresultentry', aliases: ['test result entry'] },
      { route: '/layout/labentry/testresultapproval', aliases: ['test result approval'] },
      { route: '/layout/ipd', aliases: ['ipd', 'new admission'] },
      { route: '/layout/ipd-dashboard', aliases: ['ipd dashboard'] },
      { route: '/layout/doctor-dashboard', aliases: ['doctor dashboard'] },
      { route: '/layout/EMR', aliases: ['emr'] },
      { route: '/layout/DentalEmr', aliases: ['dental emr'] },
      { route: '/layout/icons', aliases: ['icons'] },
      { route: '/layout/user-profile', aliases: ['profile', 'user profile'] },
      { route: '/layout/otlist', aliases: ['ot list'] },
      { route: '/image-analyzer', aliases: ['image analyzer'] },
      { route: '/opticaldashboard', aliases: ['optical dashboard'] },
      { route: '/print-otconsent', aliases: ['print ot consent'] },
      { route: '/login', aliases: ['login'] },
      { route: '/loggedout', aliases: ['logout', 'logged out'] },
    ];

    this.navigationRouteMap = {};

    for (const item of routeCatalog) {
      this.registerNavigationAlias(item.route, item.route);

      for (const autoAlias of this.buildNavigationAliasesFromRoute(item.route)) {
        this.registerNavigationAlias(autoAlias, item.route);
      }

      if (item.aliases && item.aliases.length > 0) {
        for (const alias of item.aliases) {
          this.registerNavigationAlias(alias, item.route);
        }
      }
    }
  }

  private registerNavigationAlias(alias: string, route: string): void {
    const normalizedAlias = this.normalizeNavigationCommand(alias);
    if (normalizedAlias) {
      this.navigationRouteMap[normalizedAlias] = route;
    }
  }

  setAllowedNavigationRoutes(routes: string[]): void {
    if (!routes || routes.length === 0) {
      this.allowedNavigationRoutes = null;
      return;
    }

    this.allowedNavigationRoutes = new Set(
      routes
        .filter((x) => !!x)
        .map((x) => this.normalizeRoutePath(x))
        .map((x) => this.getRoutePermissionKey(x))
    );
  }

  registerNavigationMenuRoutes(menuItems: Array<{ route: string; label?: string; aliases?: string[] }>): void {
    if (!menuItems || menuItems.length === 0) {
      return;
    }

    for (const item of menuItems) {
      if (!item || !item.route) {
        continue;
      }

      const normalizedRoute = this.normalizeRoutePath(item.route);
      this.registerNavigationAlias(normalizedRoute, normalizedRoute);

      for (const autoAlias of this.buildNavigationAliasesFromRoute(normalizedRoute)) {
        this.registerNavigationAlias(autoAlias, normalizedRoute);
      }

      if (item.label) {
        this.registerNavigationAlias(item.label, normalizedRoute);
      }

      if (item.aliases && item.aliases.length > 0) {
        for (const alias of item.aliases) {
          this.registerNavigationAlias(alias, normalizedRoute);
        }
      }
    }
  }

  private normalizeRoutePath(routePath: string): string {
    if (!routePath) {
      return '';
    }

    const trimmed = routePath.trim().split('?')[0].split('#')[0];
    if (trimmed.startsWith('/')) {
      return trimmed;
    }

    if (trimmed.startsWith('layout/')) {
      return '/' + trimmed;
    }

    return '/layout/' + trimmed;
  }

  private getRoutePermissionKey(routePath: string): string {
    return this.normalizeRoutePath(routePath).toLowerCase();
  }

  private normalizeNavigationCommand(command: string): string {
    let normalized = (command || '')
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\b(go to|goto|open|navigate to|navigate|take me to|show me|move to|switch to|go back to|back to|back|return to)\b/g, ' ')
      .replace(/\b(page|screen|module|menu|tab|the|a|please|kindly|can you|could you|would you|me)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    for (const [pattern, replacement] of this.navigationCorrectionRules) {
      normalized = normalized.replace(pattern, replacement);
    }

    normalized = normalized.replace(/\s+/g, ' ').trim();

    if (normalized.startsWith('to ')) {
      normalized = normalized.substring(3).trim();
    }

    return normalized;
  }

  private buildNavigationAliasesFromRoute(routePath: string): string[] {
    const normalizedRoute = this.normalizeRoutePath(routePath);
    const routeWithoutLayout = normalizedRoute.replace(/^\/layout\//, '').replace(/^\//, '');
    if (!routeWithoutLayout) {
      return [];
    }

    const aliases = new Set<string>();
    const segments = routeWithoutLayout.split('/').filter((segment) => !!segment);

    const pathAlias = segments
      .map((segment) => this.toNavigationWords(segment))
      .filter((segment) => !!segment)
      .join(' ')
      .trim();

    if (pathAlias) {
      aliases.add(pathAlias);
    }

    if (segments.length > 0) {
      aliases.add(this.toNavigationWords(segments[segments.length - 1]));
    }

    return Array.from(aliases).filter((alias) => !!alias);
  }

  private toNavigationWords(value: string): string {
    return (value || '')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/[-_]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  private resolveNavigationRoute(command: string): { route: string | null; reason: 'matched' | 'unrecognized' | 'restricted' } {
    const normalized = this.normalizeNavigationCommand(command);
    if (!normalized) {
      return { route: null, reason: 'unrecognized' };
    }

    let resolvedRoute: string | null = this.navigationRouteMap[normalized] || null;

    if (!resolvedRoute) {
      const aliases = Object.keys(this.navigationRouteMap).sort((a, b) => b.length - a.length);
      for (const alias of aliases) {
        if (normalized.includes(alias)) {
          resolvedRoute = this.navigationRouteMap[alias];
          break;
        }
      }
    }

    if (!resolvedRoute) {
      return { route: null, reason: 'unrecognized' };
    }

    const finalRoute = this.normalizeRoutePath(resolvedRoute);
    if (this.allowedNavigationRoutes && this.allowedNavigationRoutes.size > 0) {
      if (!this.allowedNavigationRoutes.has(this.getRoutePermissionKey(finalRoute))) {
        return { route: null, reason: 'restricted' };
      }
    }

    return { route: finalRoute, reason: 'matched' };
  }

  texttospeak(text: string): void {
    const synth = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'hi-IN'; // Change to 'hi-IN', 'fr-FR', etc. as needed
    synth.speak(utterance);
  }

  audiostop(): void {
    window.speechSynthesis.cancel();
  }
  init() {
    if (environment.speachtotexttype == 'azure') {
      // this.recognizer.startContinuousRecognitionAsync();
    } else {
      const browser = Bowser.getParser(window.navigator.userAgent);
      const bName = browser.getBrowser();
      if (bName.name != 'Firefox') {
        this.recognition.interimResults = false;
        this.recognition.lang = this.speakinglang;

        this.recognition.addEventListener('result', this.onResult.bind(this));

      }
    }

  }
  startAzureRecognition(type) {
    const speechConfig = sdk.SpeechConfig.fromSubscription(
      environment.azureKey || null,            // your Azure key
      'centralindia'         // e.g., 'centralindia'
    );

    speechConfig.speechRecognitionLanguage = this.speakinglang || 'en-US';

    const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();


    if (this.recognizer) {
      this.recognizer.close(); // SAFELY CLOSE
      this.recognizer = null;
    }
    this.recognizer = new sdk.SpeechRecognizer(speechConfig, audioConfig);

    this.recognizer.recognized = (s, e) => {
      if (e.result.reason === sdk.ResultReason.RecognizedSpeech) {
        console.log('Final result:', e.result.text);

        this.onAzureResult(type, e.result.text);


      } else if (e.result.reason === sdk.ResultReason.NoMatch) {
        console.log('No match found.');
      }
    };

    this.recognizer.canceled = (s, e) => {
      console.warn('Canceled:', e.errorDetails);
    };

    this.recognizer.sessionStopped = (s, e) => {
      console.log('Session stopped');
      this.recognizer?.stopContinuousRecognitionAsync();
    };

    this.recognizer.startContinuousRecognitionAsync();
  }
  private onAzureResult(type, text: string) {
    let cleanedText = text.trim();
    // Remove unnecessary trailing dots if it's a single word
    if (cleanedText.split(' ').length === 1) {
      cleanedText = cleanedText.replace(/[.。]+$/, '');
    }
    // Optional: force a space before new text
    if (this.tempWords && !this.tempWords.endsWith(' ')) {
      this.tempWords += ' ';
    }

    this.tempWords += cleanedText;

    this.wordConcat(type)

  }
  private onResult(e: any) {

    const transcript = Array.from(e.results)
      .map((result) => result[0])
      .map((result) => result.transcript)
      .join('')
      .trim();

    this.tempWords = transcript;

  }

  stopAzureRecognition() {
    if (!this.recognizer) return;

    this.recognizer.stopContinuousRecognitionAsync(
      () => {
        console.log('Recognition stopped.');
        this.recognizer?.close();
        this.recognizer = null;
      },
      (err) => {
        console.error('Stop error:', err);
        this.recognizer?.close();
        this.recognizer = null;
      }
    );
  }


  start(type: any) {

    this.startTime = this.datePipe.transform(this.authService.localDate, "HH:mm:ss");
    if (type == 'Examination Comments') {
      this.Examinationdisable = false;
      this.isStoppedSpeechRecog1 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog1) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog1) {
            this.recognition.stop();
          } else {
            this.wordConcat(type)
            this.recognition.start();
          }
        });
      }

    } else if (type == 'CallCenter') {
      this.btnenabledisablecallcenter = false;
      this.isStoppedSpeechRecog11 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog11) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog11) {
            this.recognition.stop();
          } else {
            this.wordConcat(type)
            this.recognition.start();
          }
        });
      }
    } else if (type == 'Navigation') {
      if (!this.navigationVoiceDisable) {
        return;
      }
      this.navigationVoiceDisable = false;
      this.isStoppedSpeechRecog12 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog12) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        try {
          this.recognition.start();
        } catch (error) {
          this.navigationVoiceDisable = true;
          this.isStoppedSpeechRecog12 = true;
          return;
        }
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog12) {
            this.recognition.stop();
          } else {
            this.wordConcat(type)
            try {
              this.recognition.start();
            } catch (error) {
              this.isStoppedSpeechRecog12 = true;
              this.navigationVoiceDisable = true;
            }
          }
        });
      }
    } else if (type == 'Diagnosis Comments') {
      this.Diagnosisdisable = false;
      this.isStoppedSpeechRecog2 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog2) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog2) {
            this.recognition.stop();
          } else {
            this.wordConcat(type)
            this.recognition.start();
          }
        });
      }
    } else if (type == 'Medicine Name') {
      this.MedicineNamedisable = false;
      this.isStoppedSpeechRecog3 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog3) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog3) {
            this.recognition.stop();
            console.log("End speech recognition")
          } else {
            this.wordConcat(type)
            this.recognition.start();
          }
        });
      }
    } else if (type == 'Next Review Note') {
      this.Reviewdisable = false;
      this.isStoppedSpeechRecog4 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog4) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog4) {
            this.recognition.stop();
            console.log("End speech recognition")
          } else {
            this.wordConcat(type)
            this.recognition.start();
          }
        });
      }
    } else if (type == 'Counselor Remarks') {
      this.CounselorRemarkdisable = false;
      this.isStoppedSpeechRecog13 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog13) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog13) {
            this.recognition.stop();
          } else {
            this.wordConcat(type);
            this.recognition.start();
          }
        });
      }
    } else if (type == 'Surgery Search') {
      this.Surgerydisable = false;
      this.isStoppedSpeechRecog5 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog5) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog5) {
            this.recognition.stop();
          } else {
            this.wordConcat(type)
            this.recognition.start();
          }
        });
      }
    } else if (type == 'Surgery') {
      this.Surgerytxtdisable = false;
      this.isStoppedSpeechRecog9 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog9) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog9) {
            this.recognition.stop();
          } else {
            this.wordConcat(type)
            this.recognition.start();
          }
        });
      }
    } else if (type == 'NewSurgery Search') {
      this.NewSurgerydisable = false;
      this.isStoppedSpeechRecog10 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog10) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog10) {
            this.recognition.stop();
          } else {
            this.wordConcat(type)
            this.recognition.start();
          }
        });
      }
    } else if (type == 'Medicine Search') {
      this.MedicineSearchdisable = false;
      this.isStoppedSpeechRecog6 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog6) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog6) {
            this.recognition.stop();
          } else {
            this.wordConcat(type)
            this.recognition.start();
          }
        });
      }
    } else if (type == 'Investigation Search') {
      this.Investigationdisable = false;
      this.isStoppedSpeechRecog7 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog7) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog7) {
            this.recognition.stop();
          } else {
            this.wordConcat(type)
            this.recognition.start();
          }
        });
      }
    } else {
      this.btnenabledisable = false;
      this.isStoppedSpeechRecog8 = false;
      if (environment.speachtotexttype == 'azure') {
        if (this.isStoppedSpeechRecog8) {
          this.stopAzureRecognition();
        } else {
          this.startAzureRecognition(type);
        }
      } else {
        this.recognition.start();
        this.recognition.addEventListener('end', (condition) => {
          if (this.isStoppedSpeechRecog8) {
            this.recognition.stop();
          } else {
            this.wordConcat(type)
            this.recognition.start();
          }
        });
      }
    }

  }
  stop(type?: any) {

    this.endtime = this.datePipe.transform(this.authService.localDate, "HH:mm:ss");
    if (type == 'Examination Comments') {
      this.module = 'emr';
      this.Examinationdisable = true;
      this.isStoppedSpeechRecog1 = true;
    } else if (type == 'Diagnosis Comments') {
      this.module = 'emr';
      this.Diagnosisdisable = true;
      this.isStoppedSpeechRecog2 = true;
    } else if (type == 'Medicine Name') {
      this.module = 'emr';
      this.MedicineNamedisable = true;
      this.isStoppedSpeechRecog3 = true;
    } else if (type == 'Next Review Note') {
      this.module = 'emr';
      this.Reviewdisable = true;
      this.isStoppedSpeechRecog4 = true;
    } else if (type == 'Surgery Search') {
      this.module = 'emr';
      this.Surgerydisable = true;
      this.isStoppedSpeechRecog5 = true;
    } else if (type == 'Surgery') {
      this.module = 'emr';
      this.Surgerytxtdisable = true;
      this.isStoppedSpeechRecog9 = true;
    } else if (type == 'Medicine Search') {
      this.module = 'emr';
      this.MedicineSearchdisable = true;
      this.isStoppedSpeechRecog6 = true;
    } else if (type == 'Investigation Search') {
      this.module = 'emr';
      this.Investigationdisable = true;
      this.isStoppedSpeechRecog7 = true;
    } else if (type == 'NewSurgery Search') {
      this.module = 'emr';
      this.NewSurgerydisable = true;
      this.isStoppedSpeechRecog10 = true;
    } else if (type == 'CallCenter') {
      this.module = 'Appointment';
      this.btnenabledisablecallcenter = true;
      this.isStoppedSpeechRecog11 = true;

    } else if (type == 'Navigation') {
      this.module = 'Dashboard';
      this.navigationVoiceDisable = true;
      this.isStoppedSpeechRecog12 = true;

    } else if (type == 'Counselor Remarks') {
      this.module = 'emr';
      this.CounselorRemarkdisable = true;
      this.isStoppedSpeechRecog13 = true;
    }
    else {
      this.module = 'Registration';
      this.btnenabledisable = true;
      this.isStoppedSpeechRecog8 = true;
    }

    // Avoid recursive navigation events: stop() should not emit navigationRoute$ again.
    if (type !== 'Navigation') {
      this.wordConcat(type)
    }
    if (environment.speachtotexttype == 'azure') {
      this.stopAzureRecognition();
    } else {
      try {
        this.recognition.stop();
      } catch (error) {
      }
    }
    this.savevoiceText(this.module, type);
  }

  wordConcat(type: any) {
    if (type == 'Examination Comments') {
      if (this.tempWords != '' && this.ECtext != '' && this.ECtext != undefined) {
        this.ECtext = this.ECtext + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.ECtext = this.tempWords;
      }
      this.sendingtext = this.ECtext;
    } else if (type == 'CallCenter') {
      if (this.callCentertext != '' && this.tempWords != '') {
        this.callCentertext = this.callCentertext + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.callCentertext = this.tempWords;
      }
      this.sendingtext = this.callCentertext;
    } else if (type == 'Navigation') {
      if (this.navigationVoiceText != '' && this.tempWords != '') {
        this.navigationVoiceText = this.navigationVoiceText + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.navigationVoiceText = this.tempWords;
      }
      this.sendingtext = this.navigationVoiceText;

      const navigationResult = this.resolveNavigationRoute(this.navigationVoiceText);
      this.navigationRouteSubject.next({
        route: navigationResult.route,
        command: this.navigationVoiceText,
        reason: navigationResult.reason,
      });
    } else if (type == 'Diagnosis Comments') {
      if (this.tempWords != '' && this.DCtext != '') {
        this.DCtext = this.DCtext + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.DCtext = this.tempWords;
      }
      this.sendingtext = this.DCtext;
    } else if (type == 'Medicine Name') {
      if (this.tempWords != '' && this.MAtext != '') {
        this.MAtext = this.MAtext + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.MAtext = this.tempWords;
      }
      this.sendingtext = this.MAtext;
    } else if (type == 'Next Review Note') {
      if (this.tempWords != '' && this.Reviewtext != '') {
        this.Reviewtext = this.Reviewtext + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.Reviewtext = this.tempWords;
      }
      this.sendingtext = this.Reviewtext;
    } else if (type == 'Surgery Search') {
      if (this.tempWords != '' && this.Surgerytext != '') {
        this.Surgerytext = this.Surgerytext + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.Surgerytext = this.tempWords;
      }
      this.sendingtext = this.Surgerytext;
    }
    else if (type == 'Counselor Remarks') {
      if (this.tempWords != '' && this.CRtext != '') {
        this.CRtext = this.CRtext + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.CRtext = this.tempWords;
      }
      this.sendingtext = this.CRtext;
    }

    else if (type == 'Surgery') {
      if (this.tempWords != '' && this.Surgerytxt != '') {
        this.Surgerytxt = this.Surgerytxt + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.Surgerytxt = this.tempWords;
      }
      this.sendingtext = this.Surgerytext;
    } else if (type == 'Medicine Search') {
      if (this.tempWords != '' && this.MStext != '') {
        this.MStext = this.MStext + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.MStext = this.tempWords;
      }
      this.sendingtext = this.MStext;
    } else if (type == 'Investigation Search') {
      if (this.tempWords != '' && this.IStext != '') {
        this.IStext = this.IStext + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.IStext = this.tempWords;
      }
      this.sendingtext = this.IStext;
    } else if (type == 'NewSurgery Search') {
      if (this.tempWords != '' && this.Newtext != '') {
        this.Newtext = this.Newtext + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.Newtext = this.tempWords;
      }
      this.sendingtext = this.Newtext;
    } else {
      if (this.tempWords != '' && this.text != '') {
        this.text = this.text + ' ' + this.tempWords;
      } else if (this.tempWords != '') {
        this.text = this.tempWords;
      }
      this.sendingtext = this.text;
    }

    this.tempWords = '';
  }

  savevoiceText(module, option) {

    if (this.sendingtext != '' && this.sendingtext != null && this.sendingtext != undefined) {
      let PayLoad = {
        "WebSearchMaster": {
          "Pk_TranId": 0,
          "Module": module,
          "SearchOption": option,
          "SearchText": this.sendingtext,
          "StartTime": this.startTime,
          "EndTime": this.endtime,
          "Fk_CreatedById": this.authService.Loggeduser.userid,
          "CreateDateTime": this.authService.localDate
        }
      }
      this.http.post(this.authService.newbaseUrl + "Audit/InsertWebSearchMaster", PayLoad).subscribe(x => {

      });
    }

  }
  private isStarting = false;
  private isStopping = false;
  async startDischarge(fieldName: string, callback?: (text: string) => void) {
    if (environment.speachtotexttype === 'azure') {
      if (this.isStarting || this.recognitionIsRunning) {
        console.warn('[Azure] Already starting or running');
        return;
      }

      this.isStarting = true;

      try {
        await this.stopAzureRecognizerSafely(); // Always ensure old one is closed

        const speechConfig = sdk.SpeechConfig.fromSubscription(environment.azureKey, 'centralindia');
        speechConfig.speechRecognitionLanguage = this.speakinglang || 'en-US';

        const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();

        this.recognizer = new sdk.SpeechRecognizer(speechConfig, audioConfig);

        this.recognizer.recognized = (s, e) => {
          if (e.result.reason === sdk.ResultReason.RecognizedSpeech) {
            const transcript = e.result.text.trim().replace(/[.。]+$/, '');
            if (callback) callback(transcript);
          }
        };

        this.recognizer.canceled = (s, e) => {
          console.warn('[Azure] Canceled:', e.errorDetails);
          this.stopAzureRecognizerSafely();
        };

        this.recognizer.sessionStopped = () => {
          console.log('[Azure] Session stopped');
          this.stopAzureRecognizerSafely();
        };

        await new Promise<void>((resolve, reject) => {
          this.recognizer!.startContinuousRecognitionAsync(
            () => {
              console.log('[Azure] Started');
              this.recognitionIsRunning = true;
              this.isStarting = false;
              resolve();
            },
            (err) => {
              console.error('[Azure] Start failed:', err);
              this.isStarting = false;
              this.recognitionIsRunning = false;
              reject(err);
            }
          );
        });

      } catch (err) {
        console.error('[Azure] startDischarge error:', err);
        this.isStarting = false;
        this.recognitionIsRunning = false;
      }

    } else {
      if (!this.recognition) return;

      this.isDischargeRecognitionStopped = false;
      this.activeDischargeField = fieldName;

      const restartRecognition = () => {
        if (!this.isDischargeRecognitionStopped && !this.recognitionIsRunning) {
          console.log(`[Speech] Restarting for ${fieldName} after safe delay`);
          this.recognitionIsRunning = true;
          try {

            this.recognition.start();
          } catch (err) {
            console.warn('Restart error:', err);
          }
        }
      };

      this.recognition.onresult = (event: any) => {
        const last = event.results[event.resultIndex];
        if (!last.isFinal) return;

        const transcript = last[0].transcript.trim();
        this.dischargeTextMap[fieldName] = transcript;

        if (callback) callback(transcript);
        console.log(`[Speech FINAL] ${fieldName}:`, transcript);
      };

      this.recognition.onend = () => {
        this.recognitionIsRunning = false;

        if (!this.isDischargeRecognitionStopped) {
          setTimeout(() => restartRecognition(), 300);
        }
      };

      if (this.recognitionIsRunning) {
        console.log(`[Speech] Recognition already running, aborting to restart...`);
        this.recognition.abort();
        return;
      }

      this.recognitionIsRunning = true;
      try {
        console.log(`[Speech] Starting for ${fieldName}...`);
        this.recognition.start();
      } catch (err) {
        console.warn('Start error:', err);
      }
    }
  }



  stopDischarge(fieldName: string) {

    this.isDischargeRecognitionStopped = true;
    if (environment.speachtotexttype == 'azure') {
      this.stopAzureRecognizerSafely();
    } else {
      this.recognition.stop();
    }

  }
  stopDischargeazure() {
    if (this.recognizer) {
      const r = this.recognizer;

      // Detach early to prevent re-use
      this.recognizer = null;

      r.stopContinuousRecognitionAsync(
        () => {
          try {
            r.recognized = undefined;
            r.canceled = undefined;
            r.sessionStopped = undefined;

            r.close();
            console.log('[Azure] Recognizer stopped and closed.');
          } catch (err) {
            console.error('[Azure] Error during close:', err);
          }
        },
        (err) => {
          console.error('[Azure] Error during stop:', err);
        }
      );
    }

    // Optional but recommended: release mic tracks manually
    navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
      stream.getTracks().forEach(track => track.stop());
      console.log('[Azure] Microphone released manually.');
    }).catch(err => {
      console.warn('[Azure] Mic cleanup failed:', err);
    });
  }
  async stopAzureRecognizerSafely(): Promise<void> {
    if (this.isStopping || !this.recognizer) {
      return;
    }

    this.isStopping = true;
    this.recognitionIsRunning = false;

    const recognizerToClose = this.recognizer;
    this.recognizer = null;

    try {
      await new Promise<void>((resolve, reject) => {
        recognizerToClose.stopContinuousRecognitionAsync(
          () => {
            try {
              recognizerToClose.close();
              console.log('[Azure] Recognition stopped.');
              resolve();
            } catch (closeErr) {
              console.error('[Azure] Close failed:', closeErr);
              resolve(); // don't block on close
            }
          },
          (stopErr) => {
            console.error('[Azure] Stop failed:', stopErr);
            resolve(); // still resolve to continue cleanup
          }
        );
      });
    } catch (err) {
      console.error('[Azure] Exception during stop:', err);
    } finally {
      this.isStopping = false;
    }
  }

  destroy(): void {
    try {
      this.recognition.onresult = null;
      this.recognition.onend = null;
      this.recognizer.recognized = null;
    } catch { }

    this.recognitionIsRunning = false;
    this.isDischargeRecognitionStopped = true;
  }


}
